/**
 * The DecoNetwork write journal as the backoffice reads it: one entry per
 * write, with what was there before, what was sent and what came back.
 */
import { z } from 'zod';
export const zScritturaDeco = z.object({
    id: z.string(),
    /** ISO timestamp. */
    quando: z.string(),
    /** The endpoint called. */
    comando: z.string(),
    suCosa: z.string(),
    riferimento: z.string(),
    chi: z.string(),
    esito: z.enum(['riuscita', 'fallita', 'incerta', 'non-partita']),
    /** A row with no outcome saved reads «nessun esito salvato». */
    motivo: z.string().nullable(),
    tentativi: z.number(),
    prima: z.unknown(),
    mandato: z.unknown(),
    risposta: z.unknown(),
    verifica: z.enum(['scritta', 'non-scritta']).nullable(),
    verificataIl: z.string().nullable(),
});
export const zScrittureDeco = z.array(zScritturaDeco);
//# sourceMappingURL=deconetwork-writes.js.map